import classnames from "classnames"
import { Back } from "src/app/components/Icons"

export const FormGrid = (props) => {
  const cls = classnames("form-grid", {})
  return <div className={cls}>{props.children}</div>
}

export const FormColumn = (props) => {
  const cls = classnames("form-column", {
    padded: props.padded,
  })
  return <div className={cls}>{props.children}</div>
}

export const Stack = (props) => {
  const cls = classnames(`stack ${props.className ? props.className : ""}`, {
    "gap-1": props.gap1 || props.gap === 1,
    "gap-2": props.gap2 || props.gap === 2,
    "gap-4": props.gap4 || props.gap === 4,
    "gap-6": props.gap6 || props.gap === 6,
  })
  return <div className={cls}>{props.children}</div>
}

export const StackRow = (props) => {
  const cls = classnames(`stack-row ${props.className ? props.className : ""}`, {
    "gap-1": props.gap1 || props.gap === 1,
    "gap-2": props.gap2 || props.gap === 2,
    "gap-4": props.gap4 || props.gap === 4,
    "gap-6": props.gap6 || props.gap === 6,
    "items-stretch": props.itemsStretch || props.items === "stretch",
    "justify-center": props.justifyCenter || props.justify === "center",
  })
  if (props.nodeType === "ul") return <ul className={cls}>{props.children}</ul>
  return <div className={cls}>{props.children}</div>
}

export function GridMapOverlay({ children, className = "" }) {
  return <div className={`grid-map-overlay ${className}`}>{children}</div>
}

export function GridMapOverlayHeader({ children }) {
  return <header>{children}</header>
}

export function NavTitleGrid({ children }) {
  return <div className="nav-title-grid">{children}</div>
}

export function HeaderNav(props) {
  const backButtonOnClick = props.backButtonOnClick
  const backButtonText = props.backButtonText
  const className = props.className ?? ""
  return (
    <nav className={className}>
      <NavTitleGrid>
        <button className="nav-start" onClick={() => backButtonOnClick()}>
          <Back /> <span className="py-2 pr-4">{backButtonText}</span>
        </button>
        <h1 className="title">{props.title}</h1>
        <div className="nav-end">{props.navEnd}</div>
      </NavTitleGrid>
    </nav>
  )
}

export function GridMapOverlayMain({ className = "", children }) {
  return <main className={className}>{children}</main>
}

export function LibrarySearchWrapper({ children }) {
  return <div className="form-column">{children}</div>
}

export const GridMainStack = (props) => {
  const cls = classnames(`grid-main-stack ${props.className ? props.className : ""}`, {
    "gap-2": props.gap2,
    "gap-4": props.gap4,
  })
  if (props.nodeType === "ul") return <ul className={cls}>{props.children}</ul>
  return <div className={cls}>{props.children}</div>
}
